import { useI18n } from 'vue-i18n';
import { useIndexStore } from '~/store';

export const head = function () {
  const { t } = useI18n();
  const store = useIndexStore();
  const config = {
    htmlAttrs: {
      // 如果当前未启用主题切换按钮，则移除样式
      // 导航头主题按钮切换事件里加了一个逻辑，让class主题类名附加更迅速，解决浅暗色皮肤变化有延迟现象
      class: store.globalThemeSwitcher ? (store.globalTheme === 'light' ? 'day-mode' : 'night-mode') : '',
    },
    title: t('seo.index_title'),
    meta: [
      {
        rel: 'icon',
        type: 'image/x-icon',
        href: '/fav.ico',
      },
      {
        charset: 'utf-8',
      },
      {
        hid: 'description',
        name: 'description',
        content: t('seo.index_desc'),
      },
      {
        name: 'renderer',
        content: 'webkit',
      },
      {
        hid: 'keywords',
        name: 'keywords',
        content: t('seo.index_key'),
      },
      {
        hid: 'og:url',
        name: 'og:url',
        content: 'https://www.bitmart.com',
      },
      {
        hid: 'og:type',
        name: 'og:type',
        content: 'website',
      },
      {
        hid: 'og:title',
        name: 'og:title',
        content: t('seo.index_title'),
      },
      {
        hid: 'og:description',
        name: 'og:description',
        content: t('seo.index_desc'),
      },
      {
        hid: 'og:site_name',
        name: 'og:site_name',
        content: 'Bitmart',
      },
      {
        hid: 'og:image',
        name: 'og:image',
        content: 'https://www.bitmart.com/img/bitmart_seo.jpg',
      },
      {
        hid: 'twitter:url',
        name: 'twitter:url',
        content: 'https://www.bitmart.com',
      },
      {
        hid: 'twitter:type',
        name: 'twitter:type',
        content: 'website',
      },
      {
        hid: 'twitter:title',
        name: 'twitter:title',
        content: t('seo.index_title'),
      },
      {
        hid: 'twitter:description',
        name: 'twitter:description',
        content: t('seo.index_desc'),
      },
      {
        hid: 'twitter:site_name',
        name: 'twitter:site_name',
        content: 'Bitmart',
      },
      {
        hid: 'twitter:image',
        name: 'twitter:image',
        content: 'https://www.bitmart.com/img/bitmart_seo.jpg',
      },
      {
        hid: 'twitter:image:src',
        name: 'twitter:image:src',
        content: 'https://www.bitmart.com/img/bitmart_seo.jpg',
      },
      {
        hid: 'twitter:card',
        name: 'twitter:card',
        content: 'summary_large_image',
      },
      {
        hid: 'viewport',
        name: 'viewport',
        content: 'width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=no, viewport-fit=cover',
      },
    ],
  };
  return config;
};
